export const RoleNames = {
    Administrator: "Administrator",
    Vyvojar: "Vyvojar"
};



// WEBPACK FOOTER //
// ./src/components/common/RoleNames.js